// extracted by mini-css-extract-plugin
export default {"container":"Home_container__wOY5E","cardContainer":"Home_cardContainer__XhBjU","skeletonImg":"Home_skeletonImg__cADNk","skeletonText":"Home_skeletonText__ZJke4"};